module.exports = __webpack_public_path__ + "static/media/mobile17.03ac6d1c.png";